<template>
  <MainLayout>
    <div
      style="
        height: 100%;
        background-color: white;
        position: fixed;
        width: 100%;
        left: 0;
        top: 0;
        padding-left: var(--sidebar-width);
        padding-top: var(--nav-height);
      "
    >
      <div id="iframe-container"></div>
      <template v-if="linkIframe">
        <iframe
          :src="linkIframe"
          allowfullscreen="true"
          sandbox="allow-popups allow-forms allow-same-origin allow-scripts allow-top-navigation allow-top-navigation-by-user-activation allow-downloads"
          style="display: block; height: 100%; overflow: auto; width: 100%; border: none"
        ></iframe>
      </template>
    </div>
  </MainLayout>
</template>

<script>
import { mapGetters } from 'vuex'
import { FEATURE } from '@/constants/feature'

export default {
  name: 'AllInOneChat',
  components: {},
  data() {
    return {
      baseUrl: 'https://cms.enterprise.zwiz.app'
      // baseUrl: 'http://localhost:3000'
    }
  },
  computed: {
    ...mapGetters(['selectedBot']),
    hostName() {
      return window.location.hostname
    },
    linkIframe() {
      if (!this.$store.getters.currentLang) {
        return null
      }

      let tempBaseUrl = this.baseUrl

      if (this.hostName === 'localhost') {
        tempBaseUrl = 'http://localhost:3000'
      } else if (this.hostName === 'develop-facebook-template.enterprise.zwiz.app') {
        tempBaseUrl = 'https://develop.cms.enterprise.zwiz.app'
      } else {
        tempBaseUrl = this.baseUrl
      }

      const url = new URL(
        `${tempBaseUrl}/${this.$store.getters.currentLang}/all-in-one-chat-iframe`
      )
      const query = { ...this.$route.query }
      if (query.inbox) {
        url.searchParams.append('inbox', query.inbox)
      }
      if (query.search || query.app) {
        url.searchParams.append(
          'query',
          JSON.stringify({
            search: query.search,
            app: query.app
          })
        )
      }
      return url.href
    }
  },
  beforeMount() {
    const features = this.selectedBot.features.split(',')
    const useNewAioChat = features.includes(FEATURE.ALL_IN_ONE_CHAT_NEW)
    if (!useNewAioChat) {
      this.$router.push('/' + this.$store.getters.currentLang + '/dashboard')
    }
  },

  mounted() {
    window.addEventListener('message', this.handleMessage)
  },
  beforeDestroy() {
    window.removeEventListener('message', this.handleMessage)
  },
  methods: {
    handleMessage(event) {
      if (event.data.event_id === 'open_external_link') {
        if (window.innerWidth < 960) {
          window.open(event.data.url, '_blank')
        } else {
          if (
            event.data.url.includes('https://enterprise-drive.zwiz.app') ||
            event.data.url.includes('https://enterprise-s3.zwiz.app')
          ) {
            this.downloadFile(event.data.url, `file_${Date.now()}`)
          } else {
            window.open(event.data.url, '_blank')
          }
        }
      } else if (event.data.event_id === 'copy_to_clipboard') {
        if (event.data.value) navigator.clipboard.writeText(event.data.value)
      } else if (event.data.event_id === 'open_link') {
        window.open(event.data.url, '_self')
      }
    },
    downloadFile(url, filename) {
      fetch(url)
        .then((response) => response.blob())
        .then((blob) => {
          const blobUrl = URL.createObjectURL(blob)
          const a = document.createElement('a')
          a.href = blobUrl
          a.download = filename
          document.body.appendChild(a)
          a.click()
          document.body.removeChild(a)
          URL.revokeObjectURL(blobUrl)
        })
        .catch((error) => console.error('Download failed:', error))
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/view/AllInOneChat/AllInOneChat.vue